var map = {
  "./da.json": [
    "10732",
    [
      63997
    ]
  ],
  "./fi.json": [
    "84526",
    [
      55043
    ]
  ],
  "./sv.json": [
    "77230",
    [
      65187
    ]
  ],
  "./ja.json": [
    "10362",
    [
      24807
    ]
  ],
  "./lt.json": [
    "52379",
    [
      40475
    ]
  ],
  "./sl.json": [
    "92132",
    [
      24197
    ]
  ],
  "./fr.json": [
    "48471",
    [
      10236
    ]
  ],
  "./es.json": [
    "90491",
    [
      30792
    ]
  ],
  "./no.json": [
    "85480",
    [
      75249
    ]
  ],
  "./cs.json": [
    "61677",
    [
      87902
    ]
  ],
  "./en.json": [
    "48972",
    [
      50013
    ]
  ],
  "./description/en.json": [
    "92523",
    [
      58616
    ]
  ],
  "./pl.json": [
    "85935",
    [
      86212
    ]
  ],
  "./hu.json": [
    "59135",
    [
      54237
    ]
  ],
  "./nl.json": [
    "90245",
    [
      67942
    ]
  ],
  "./de.json": [
    "40496",
    [
      84393
    ]
  ],
  "./pt.json": [
    "8247",
    [
      44252
    ]
  ],
  "./it.json": [
    "15794",
    [
      87087
    ]
  ],
  "./et.json": [
    "29062",
    [
      56875
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 13606;
module.exports = __rspack_async_context;
